import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

class Confirmation extends Component {
  componentDidMount = () => {
    if (this.props.customerInfo.get("signedIn")) {
      this.props.history.push("/");
    }
  };

  render() {
    return (
      <div
        className="signin animated fadeIn mar-b-100 mar-t-100"
        style={{ color: "black" }}
      >
        <div className="box-outer">
          <div className="box-inner">
            <h1>Password Changed</h1>
            <div>
              <p>
                Your password has been successfully changed. Would you like to{" "}
                <Link to="login">
                  <span className="lnk">login?</span>
                </Link>
              </p>
              <span>
                Are you still having trouble recovering your password?
              </span>
              <br />
              <Link to="contact">
                <span className="lnk">Contact Us</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    customerInfo: state.customerInfo,
  }),
  null
)(Confirmation);
